import { render } from "./RegulationsView.vue?vue&type=template&id=fed973ac&scoped=true"
import script from "./RegulationsView.vue?vue&type=script&lang=js"
export * from "./RegulationsView.vue?vue&type=script&lang=js"

import "./RegulationsView.vue?vue&type=style&index=0&id=fed973ac&scoped=true&lang=css"

import exportComponent from "C:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed973ac"]])

export default __exports__